import { render, staticRenderFns } from "./RaceChart.vue?vue&type=template&id=a8ed88fc"
import script from "./RaceChart.vue?vue&type=script&lang=js"
export * from "./RaceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports